// extracted by mini-css-extract-plugin
module.exports = {"label":"FilterSelect-module--label--2VePp","title":"FilterSelect-module--title--19Sqy","value":"FilterSelect-module--value--3TRlY","select":"FilterSelect-module--select--16aCj"};